import React from 'react';
import Link from 'gatsby-link';
import styled from 'react-emotion';
import Headroom from 'react-headroom';
// import Logo from "../icons/logo/Logo";
import Trophy from '../icons/fa-solid/Trophy.jsx';
import History from '../icons/fa-solid/History.jsx';
import HandsHelping from '../icons/fa-solid/HandsHelping.jsx';
import Triangle from '../icons/css/Triangle';
import { setMode, setMood, theme } from '../../config/theme.js';

import { OrbContainer, openOrbContainer } from './OrbContainer';

import DarkIcon from '../icons/solid/DarkIcon.jsx';
import LightIcon from '../icons/solid/LightIcon.jsx';

// 18.675 pixel/rem
// 1540px; 82.46rem;
// 1920px; 102.8112rem;
const HeadroomWrapDiv = styled.div`
  display: flex;
  width: 100%;
  background-color: red;
  ${HeadRoom} {
    .headroom--unpinned {
    }
  }
`;
const HeadroomDiv = styled.div`
  font-size: 1.1225rem;
  display: flex;
  margin-left: auto;
  margin-right: auto;
  width: 100%;
  max-width: ${props => props.theme.layout.max};
  margin-bottom: 1rem;
`;
const LinkLogo = styled(Link)`
  position: absolute;
  top: 0.5rem;
  z-index: 99;
  font-weight: 700;
  svg {
    height: 2.5rem;
    margin-bottom: 0;
  }
  display: inline-block;
  font-size: 1.25rem;
  margin-left: 0.75rem;
  font-family: ${props => props.theme.fontFamily.button};
  transition: all 0.4s;
  text-shadow: 0rem 0.3rem 0.5rem rgba(0, 0, 0, 0.45);
  color: ${props => props.theme.colors.cool.dim0};
  border-bottom: 2px solid ${props => props.theme.colors.warm.base};
  &:focus,
  &:hover {
    border-bottom: 2px solid ${props => props.theme.colors.fire.light};
    color: ${props => props.theme.colors.cool.lead};
    text-shadow: 0rem 0.3rem 0.5rem rgba(0, 0, 0, 0.45), -1px -1px 0 ${props => props.theme.colors.cool.dim0},
      1px -1px 0 ${props => props.theme.colors.cool.dim0}, -1px 1px 0 ${props => props.theme.colors.cool.dim0},
      1px 1px 0 ${props => props.theme.colors.cool.dim0};
  }
  @media (max-width: 500px) {
    margin-left: -0.75rem;
  }
`;
const Tri = styled(Triangle)`
  transform: skewX(0deg) scale(0.15);
  background-color: ${props => props.theme.set.dark.invertWhite};
  top: -4.8rem;
  left: -3.95rem;
  z-index: 99;
  opacity: 0.85;
  transition: ${props => props.theme.transitions.main.duration};
  @media (max-width: 600px) {
    top: -4.99rem;
    left: -4.5rem;
  }
`;
const BgTri = styled(Triangle)`
  transform: skewX(0deg) scale(0.2);
  background-color: ${props => props.theme.set.dark.bgText};
  top: -14.8rem;
  left: -3.95rem;
  z-index: 98;
  opacity: 0.95;
  transition: ${props => props.theme.transitions.main.duration};
  @media (max-width: 600px) {
    top: -14.99rem;
    left: -4.5rem;
  }
`;
const ShadowTri = styled(Triangle)`
  transform: skewX(0deg) scale(0.22);
  background-color: ${props => props.theme.colors.cool.lead};
  top: -24.8rem;
  left: -3.95rem;
  z-index: 97;
  opacity: 0.25;
  transition: ${props => props.theme.transitions.main.duration};
  @media (max-width: 600px) {
    top: -24.99rem;
    left: -4.5rem;
  }
`;
const TriLink = styled(Link)`
  max-width: 1rem;
  max-height: 1rem;
  &:focus,
  &:hover {
    ${ShadowTri} {
      opacity: 0.75;
      background-color: ${props => props.theme.colors.warm.base};
    }
  }
  padding-left: 2.25rem;
  padding-right: 0.95rem;
  @media (max-width: 600px) {
    padding-right: 0;
    padding-left: 2.25rem;
  }
`;

// const NavWrapDiv = styled.div`
//   display: inline;
//   width: 100%;
// `;

const InlineBlockDiv = styled.div`
  display: inline-block;
`;

const Nav = styled.span`
  display: flex;
  position: relative;
  flex-direction: row-reverse;
  text-align: center;
  min-width: 300px;
  transition: all 0.25s;
  z-index: 98;
  /*
  background-color: green;
  */
  font-family: ${props => props.theme.fontFamily.button};
  svg {
    g {
      stroke: ${props => props.theme.set.light.placeholder};
      fill: ${props => props.theme.colors.cool.dim0};
      stroke-width: 18;
    }
  }
  margin-bottom: -1.25rem;
  a {
    font-weight: 2rem;
    margin-left: 1rem;
  }
  padding-left: 4rem;
  ${TriLink} {
    border-bottom: 2px solid transparent;
    cursor: pointer;
    &:focus,
    &:hover {
      border-bottom: 2px solid transparent;
    }
  }
  @media (max-width: 724px) {
    padding-left: 6rem;
  }
  @media (max-width: 500px) {
    padding-left: 4rem;
  }
`;
const LinkNav = styled(Link)`
/* 
background-color: red; 
*/
text-shadow: 0.25rem 0.2rem 0.25rem rgba(0, 0, 0, 1),
  ${props => props.theme.set.light.shadow.pop};
  transition: all 0.4s;
  
  /*
  border-bottom: 2px solid transparent;
  */
  &:focus {
    color: ${props => props.theme.colors.pure.white};
    text-shadow: ${props => props.theme.set.light.shadow._3dThick};
    svg {
      g {
        fill: ${props => props.theme.colors.pure.white};
      }
    }
  }
  &:hover {
    border-bottom: 2px solid ${props => props.theme.colors.warm.base};
    color: ${props => props.theme.colors.pure.white};
    text-shadow: ${props => props.theme.set.light.shadow._3dThick};
    svg {
      g {
        fill: ${props => props.theme.colors.pure.white};
      }
    }
  }
`;
const HeadRoom = styled(Headroom)`
  ${LinkLogo} {
    color: ${props => props.theme.colors.cool.dim0};
    border-bottom: 2px solid ${props => props.theme.set.light.highlight};
    &:hover {
      color: black;
      border-bottom: 2px solid ${props => props.theme.colors.warm.base};
      /*
      border-bottom: 2px solid ${props => props.theme.set.light.highlight};
      */
    }
  }
  .headroom--unpinned {
    ${HeadroomWrapDiv} {
      height: 0px;
    }
    ${LinkNav} {
      border-bottom: 2px solid transparent;
    }
  }
  .headroom--pinned {
    box-shadow: ${props => props.theme.set.light.shadow.feature.small.main};

    background-color: ${props => props.theme.set.light.bgHeadroom};
    svg {
      g {
        fill: ${props => props.theme.set.light.highlight};
      }
    }
    ${LinkNav} {
      border-bottom: 2px solid transparent;
      color: ${props => props.theme.set.light.placeholder};
      text-shadow: 0.25rem 0.2rem 0.25rem rgba(0, 0, 0, 1), 
      ${props => props.theme.set.light.shadow._3dThinCool};

      &:focus {
        border-bottom: 2px solid transparent;
        color: ${props => props.theme.colors.pure.white};
        text-shadow: 0.25rem 0.2rem 0.25rem rgba(0, 0, 0, 1),
        ${props => props.theme.set.light.shadow._3dThinCool};
        svg {
          g {
            fill: ${props => props.theme.set.dark.highlight};
          }
        }
      }
      &:hover {
        border-bottom: 2px solid ${props => props.theme.set.light.highlight};
        color: ${props => props.theme.colors.pure.white};
        /*
        text-shadow: 0.5rem 0.2rem 0.5rem rgba(0, 0, 0, 1), 1px 0px 0 ${props => props.theme.colors.cool.ink},
          0px 1px 0 ${props => props.theme.colors.cool.ink}, 1px 1px 0 ${props => props.theme.colors.cool.ink};
        */
        text-shadow: 0.25rem 0.2rem 0.25rem rgba(0, 0, 0, 1),
        ${props => props.theme.set.light.shadow._3dThinCool};
        svg {
          g {
            fill: ${props => props.theme.set.dark.highlight};
          }
        }
      }
    }
    ${LinkLogo} {
      color: ${props => props.theme.set.light.placeholder};
      text-shadow: ${props => props.theme.set.light.shadow._3dThinCool},
      ${props => props.theme.set.light.shadow._3dThinCool};
      &:focus,
      &:hover {
        color: ${props => props.theme.set.dark.p};
        text-shadow: 0rem 0.3rem 0.5rem rgba(0, 0, 0, 0.45), -1px -1px 0 ${props => props.theme.set.light.p},
          1px -1px 0 ${props => props.theme.set.light.p}, -1px 1px 0 ${props => props.theme.set.light.p},
          1px 1px 0 ${props => props.theme.set.light.p};
      }
    }
    ${TriLink} {
      &:focus,
      &:hover {
        border-bottom: 2px solid transparent;
      }
    }
  }
`;

let path = '#';
let pathFix = '';
let scrollY = 0;
let scrollX = 0;
// let theme.lastNavOnId = '';

const setOpacity = (arr, len, opacity) => {
  let i = 0;
  for (; i < len; i++) {
    arr[i].style.opacity = opacity;
  }
};

const regex = {
  // logoPath: /\/ $/,
  productPath: /\/product\s|\/product\/\s/,
  newsPath: /\/news\s|\/news\/\s/,
  helpPath: /\/help\s|\/help\/\s/,
};
const toggleDisplay = (id = 'HeadroomWrapDiv', display = 'none') => {
  document.getElementById(id).style.display = display;
  // document.getElementById('HeadroomWrapDiv').style.display = 'none';
};
const upNav = () => {
  if (theme.lastNavOnId !== '') {
    document.getElementById(theme.lastNavOnId).style = theme.cssNav;
  }
};
const handleSubmit = e => {
  if (scrollX !== window.pageXOffset) {
    scrollX = window.pageXOffset;
  }
  if (scrollY !== window.pageYOffset) {
    scrollY = window.pageYOffset;
  }
  // force scroll back after page load:
  if (typeof setTimeout !== 'undefined') {
    setTimeout(() => {
      window.scroll(scrollX, scrollY);
    }, 0);
  }
  let orbWrapElements = document.getElementsByClassName(`${theme.set.mode.toLowerCase()}OrbWrap`);
  const orbWrapElementsLen = orbWrapElements.length;
  setOpacity(orbWrapElements, orbWrapElementsLen, 0);
  
  setMode();
  if(theme.set.mode === 'Light') {
    document.getElementById('LightIcon').style.opacity = 0.0;
    document.getElementById('DarkIcon').style.opacity = 0.7;
  }
  else {
    document.getElementById('LightIcon').style.opacity = 0.7;
    document.getElementById('DarkIcon').style.opacity = 0.0;
  }

  orbWrapElements = document.getElementsByClassName(`${theme.set.mode.toLowerCase()}OrbWrap`);
  setOpacity(orbWrapElements, orbWrapElementsLen, 1);

  setTimeout(upNav, 0);
  openOrbContainer();
};
const doNav = () => {
  if (pathFix === '/ ') {
    if (theme.lastNavOnId === 'LinkLogo') {
      return;
    }
    document.getElementById('LinkLogo').style = theme.cssNav;
    document.getElementById(theme.lastNavOnId).style = '';
    theme.lastNavOnId = 'LinkLogo';
    return;
  }
  if (regex.productPath.test(pathFix)) {
    if (theme.lastNavOnId === 'LinkProduct') {
      return;
    }
    document.getElementById('LinkProduct').style = theme.cssNav;
    document.getElementById(theme.lastNavOnId).style = '';
    theme.lastNavOnId = 'LinkProduct';
    return;
  }
  if (regex.newsPath.test(pathFix)) {
    if (theme.lastNavOnId === 'LinkNews') {
      return;
    }
    document.getElementById('LinkNews').style = theme.cssNav;
    document.getElementById(theme.lastNavOnId).style = '';
    theme.lastNavOnId = 'LinkNews';
    return;
  }
  if (regex.helpPath.test(pathFix)) {
    if (theme.lastNavOnId === 'LinkHelp') {
      return;
    }
    document.getElementById('LinkHelp').style = theme.cssNav;
    document.getElementById(theme.lastNavOnId).style = '';
    theme.lastNavOnId = 'LinkHelp';
    return;
  }
  document.getElementById(theme.lastNavOnId).style = '';
  theme.lastNavOnId = '';
};
const initNav = () => {
  if (theme.lastNavOnId !== '') {
    setTimeout(doNav, 0);
    return;
  }
  if (pathFix === '/ ') {
    document.getElementById('LinkLogo').style = theme.cssNav;
    theme.lastNavOnId = 'LinkLogo';
    return;
  }
  if (regex.productPath.test(pathFix)) {
    document.getElementById('LinkProduct').style = theme.cssNav;
    theme.lastNavOnId = 'LinkProduct';
    return;
  }
  if (regex.newsPath.test(pathFix)) {
    document.getElementById('LinkNews').style = theme.cssNav;
    theme.lastNavOnId = 'LinkNews';
    return;
  }
  if (regex.helpPath.test(pathFix)) {
    document.getElementById('LinkHelp').style = theme.cssNav;
    theme.lastNavOnId = 'LinkHelp';
  }
};

const Navigation = () => {
  if (typeof window !== 'undefined') {
    path = window.location.pathname;
  }

  pathFix = `${path} `;
  // alert(pathFix);
  setTimeout(initNav, 0);
  //  Only return if not an iframe:
  if (typeof window !== 'undefined') {
    if (window.parent.location === self.location) { 

    setTimeout(()=>{
      if(theme.set.mode === 'Light') {
        document.getElementById('LightIcon').style.opacity = 0.0;
        document.getElementById('DarkIcon').style.opacity = 0.7;
      }
      else {
        document.getElementById('LightIcon').style.opacity = 0.7;
        document.getElementById('DarkIcon').style.opacity = 0.0;
    }}, 1);

      return (
        <HeadroomWrapDiv id="HeadroomWrapDiv">
          <HeadRoom calcHeightOnResize disableInlineStyles>
            <HeadroomDiv>
              <div style={{ display: 'inline', width: '100%' }}>
                <LinkLogo to="/" id="LinkLogo">
                  SONDROS
                </LinkLogo>
                <Nav>
                  <TriLink to={path} onClick={e => handleSubmit(e)}>
                   
                    <DarkIcon />
                    <LightIcon />
                    <Tri>
                    </Tri>
                    <BgTri />
                    <ShadowTri />
                  </TriLink>

                  <LinkNav id="LinkHelp" to="/help" activeClassName="active">
                    <HandsHelping />
                    <InlineBlockDiv>
                      {`:${'\u00A0'}.${'\u00A0'}HELP`}                            
                    </InlineBlockDiv>
                  </LinkNav>
                
                  <LinkNav id="LinkNews" to="/news" activeClassName="active">
                    <History />
                    <InlineBlockDiv>
                      {`:${'\u00A0'}.${'\u00A0'}NEWS`}
                    </InlineBlockDiv>
                  </LinkNav>
                  
                  <LinkNav id="LinkProduct" to="/product" activeClassName="active">
                    <Trophy />
                    <InlineBlockDiv>
                      {`:${'\u00A0'}.${'\u00A0'}PRODUCT`}
                    </InlineBlockDiv>
                  </LinkNav>
                </Nav>
                <OrbContainer />
              </div>
            </HeadroomDiv>
          </HeadRoom>
        </HeadroomWrapDiv>
      );
    }
    else {
      // alert('app');
      return (<div />);
    }
  }
  return (<div />);
};
export default Navigation;
// paddingRight: "4rem",



// WEBPACK FOOTER //
// ./src/components/Navigation.jsx